import { useEffect } from 'react';
import { registerGuest } from 'src/services/auth';
import { useLocation } from 'react-router-dom';
import AssistantChat from 'src/components/assistant-demo';
import { RealtimeChatProvider } from 'src/contexts/app/RealtimeChatProvider';
import { useAuth } from 'src/hooks/useAuth';

interface DemoAssistantProps {
	assistantAlias: string;
	initialMessage: string;
	countryCode: string;
}

const DemoAssistant = ({
	assistantAlias,
	initialMessage,
	countryCode,
}: DemoAssistantProps) => {
	const isAuthenticated = useAuth();
	const { pathname } = useLocation();

	useEffect(() => {
		!isAuthenticated && registerGuest();
	}, [isAuthenticated, pathname]);

	return (
		<RealtimeChatProvider
			assistantAlias={assistantAlias}
			initialMessage={initialMessage}
			countryCode={countryCode}
		>
			<AssistantChat />
		</RealtimeChatProvider>
	);
};

export default DemoAssistant;
